var map = {
	"./1.png": 354,
	"./10.png": 355,
	"./11.png": 356,
	"./2.png": 357,
	"./3.png": 358,
	"./4.png": 359,
	"./5.png": 360,
	"./6.png": 361,
	"./7.png": 362,
	"./8.png": 363,
	"./9.png": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;